<template>
  <div class="px-8 mt-4">
    <v-dialog
      v-model="dialogModel"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="poModal"
      scrollable
    >
      <v-card>
        <v-toolbar dark color="green darken-2" max-height="65">
          <v-toolbar-title> {{ requestData.RequestCode }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <v-stepper alt-labels>
            <v-stepper-header>
              <v-stepper-step
                color="green"
                step="1"
                class="pa-3 pl-md-16"
                :complete="true"
              >
              <span class="text-no-wrap">Request Creation</span>
              <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(requestData.DateCreated)}}</small>
              </v-stepper-step>

              <v-divider class="my-6"></v-divider>

              <v-stepper-step
                color="green"
                :complete="requestData.DateApproved != null"
                step="2"
                class="pa-3"
                :rules="[() => unpublishData.ApprovedStatusID != 6]"
              >
                <span class="text-no-wrap">Request Approval</span>
                <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(requestData.DateApproved || unpublishData.ApprovedDate)}}</small>
              </v-stepper-step>

              <v-divider class="my-6"></v-divider>

              <v-stepper-step
                color="green"
                :complete="requestData.DateCompleted != null"
                step="3"
                class="pa-3"
                :rules="[() => unpublishData.PPMPApprovalStatusID != 6, () => unpublishData.PRApprovalStatusID != 6]"
              >
                <span class="text-no-wrap">Request Completion</span>
                <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(requestData.DateCompleted)}}</small>
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>
        <v-alert
          border="left"
          type="error"
          v-if="unpublishData.ApprovedStatusID == 6 || unpublishData.PPMPApprovalStatusID == 6 || unpublishData.PRApprovalStatusID == 6"
          prominent
          dense
          class="white--text amber accent-4"
        >
          <div v-if="unpublishData.ApprovedRemarks">
            <strong>Approver:</strong> {{ unpublishData.ApprovedRemarks }}
          </div>
          <div v-else-if="unpublishData.PPMPApprovalRemarks">
            <strong>PSU Officer:</strong> {{ unpublishData.PPMPApprovalRemarks }}
          </div>
          <div v-else-if="unpublishData.PRApprovalRemarks">
            <strong>Budget Officer:</strong> {{ unpublishData.PRApprovalRemarks }}
          </div>
        </v-alert>
        <v-alert
          border="left"
          type="error"
          v-if="requestData.IsCancelled"
          prominent
          dense
          class="white--text amber accent-4"
        >
          <strong>CANCELLED</strong><br />
          <small>Date Cancelled: {{formatDateTime(requestData.DateCancelled)}}</small>
        </v-alert>
        <v-card-text style="max-height: 900px">
          <div>
            <v-row class="my-5">
              <v-col cols="12" class="d-flex justify-center">
                <v-subheader class="font-weight-bold text-h5"
                  >REQUEST FORM</v-subheader
                >
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-5">
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Entity Name:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>Davao del Norte State College</v-subheader>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Request No:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ requestData.RequestCode }}</v-subheader>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Office:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ requestData.Office }}</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Request Type:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ requestData.RequestType }}</v-subheader>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Requestor:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ requestData.RequestedBy }}</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Date Created:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ formatDateTime(requestData.DateCreated) }}</v-subheader>
            </v-col>
          </v-row>
          </div>

        <v-btn
          color="grey darken-1"
          dark
          block
          class="elevation-0 mt-3"
          @click="print()"
        >
          <v-icon class="mr-1">mdi-printer</v-icon>
          Print
        </v-btn>
          
        <div class="d-flex mt-5 mb-5">
          <v-divider class="mt-4 mr-3"></v-divider>
          <span class="text-h6">Request Type Details</span>
          <v-divider class="mt-4 ml-3"></v-divider>
        </div>
        <v-sheet class="DarkWhite">
    <v-row no-gutters class="mt-5">
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">Budget Code:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.BudgetCode}}</v-subheader>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">PR Code:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.PRCode }}</v-subheader>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">PPMP Type To Unpublish:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.PPMPType }}</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">No. of Items To Cancel:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishItems.length }}</v-subheader>
      </v-col>
    </v-row>

    <v-row class="my-3"><v-divider></v-divider></v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">Request for additional description:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.AdditionalDescription == 1 ? "YES" : "NO" }}</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">Request for Revocation/Withdrawal of approved PR:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.PRRevocation == 1 ? "YES" : "NO" }}</v-subheader>
      </v-col>
    </v-row>
    <v-row class="my-3"><v-divider></v-divider></v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">Others:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.Others == 1 ? unpublishData.OtherDescription : "None" }}</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader class="font-weight-bold">Reason:</v-subheader>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-subheader>{{ unpublishData.Reason ? unpublishData.Reason : "None" }}</v-subheader>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="unpublishItems"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2 mt-4"
    >
      <template v-slot:top>
        <v-toolbar flat class="mx-1">
          <span class="text-subtitle-1 font-weight-bold">Puchase Request Items (To Be Deleted)</span>
          <v-spacer></v-spacer>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            StockPropertyNo: { title: 'Stock/Property No' },
            ItemName: { title: 'Item Name' },
            ItemDescription: { title: 'Item Description' },
            UnitMeasureDescription: { title: 'Unit Measure' },
            Qty: { title: 'Qty' },
            UnitCost: { title: 'Unit Cost' },
            DateCreated: { title: 'Date Created' },
            }"
          csv-title="PR Requested Items For Delete">
            <v-btn
              outlined
              color="green darken-2"
              dark
              :loading="loadingCSV"
              small
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
        </v-toolbar>
      </template>
      <template v-slot:[`item.StockPropertyNo`]="{ item }">
          <span class="text-no-wrap">{{ item.StockPropertyNo }}</span>
        </template>
        <template v-slot:[`item.Qty`]="{ item }">
          <span class="text-no-wrap">₱ {{ formatQty(item.Qty || 0) }}</span>
        </template>
        <template v-slot:[`item.Amount`]="{ item }">
          <span class="text-no-wrap">₱ {{ formatPrice((item.UnitCost * item.Qty) || 0) }}</span>
        </template>
        <template v-slot:[`item.UnitCost`]="{ item }">
          <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost || 0) }}</span>
        </template>
        <template v-slot:[`item.DateCreated`]="{ item }">
          {{ formatDateTime(item.DateCreated) }}
        </template>
    </v-data-table>
        </v-sheet>
          
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogUnpublish" max-width="500px">
          <v-card>
            <v-card-title class="headline pt-5">Confirmation</v-card-title>
            <div class="mx-6">
              Are you sure you want to cancel this Request?
            </div>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-2" outlined @click="dialogUnpublish = false">Cancel</v-btn>
              <v-btn color="red darken-2 white--text" @click="confirmUnpublish()"><v-icon>mdi-delete</v-icon> Unpublish</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-dialog
          v-model="editREQDialog"
          persistent
          max-width="750px"
          scrollable
        >
          <v-card>
            <v-card-title>
              <span>Update Request</span>
              <v-spacer></v-spacer>
              <v-btn
                    icon
                    dark
                    color="secondary2"
                    @click="editREQDialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 900px;">
              <v-form @submit.prevent ref="RequestUpdateFormRef">
              <v-container>
                ////////////////////////////////////////////////
              </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                outlined
                @click="editREQDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-2"
                class="white--text"
                @click="confirmUpdate"
                :loading="isLoading"
              >
              <v-icon class="mr-1">mdi-square-edit-outline</v-icon>
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
    
    <script>
export default {
  props: {
    requestData: {},
  },
  data: () => ({
    dialog: false,
    users: [],
    dialogModel: false,
    PurposeDialog: false,
    supplier: [],
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    dialogIARVersion: false,
    link: "",
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Added!",
      message: "",
      top: 10,
    },
    headers: [
      {
        text: "Stock/ Property No.",
        align: "start",
        sortable: false,
        value: "StockPropertyNo",
      },
      {
        text: "Item Name",
        align: "start",
        sortable: false,
        value: "ItemName",
      },
      { text: "Description", value: "ItemDescription", sortable: false },
      {
        text: "Unit Measure",
        value: "UnitMeasureDescription",
        sortable: false,
      },
      { text: "Unit Cost", align:"end", value: "UnitCost", sortable: false },
      { text: "Qty", align:"center", value: "Qty", sortable: false },
      { text: "Amount", align:"end", value: "Amount", sortable: false },
    ],
    expanded1: [],
    expanded2: [],
    singleExpand: true,
    formData: {
      RequestType: null,
        UsePPMP: false,
        PPMPType: [],
        PPMPBudgetCode: '',
        UsePR: false,
        PRNumber: '',
        PRRevocation: false,
        AdditionalDescription: false,
        Others: false,
        OtherDescription: null,
        Reason: null,
    },
    itemList: [],
    itemList_filtered: [],
    tabs: null,
    submitbtn: false,
    dispenseTypes: [],
    ICSDispenseType: null,
    DSDialog: false,
    DSType: null,
    editDescription: false,
    dialogConfirmSubmit: false,
    generatedICSID : [],
    dialogUnpublish: false,
    isLoading: false,
    dialogProcess: false,
    approveData: [],
    pendingData: [],
    editREQDialog: false,
    unpublishItems: [],
    unpublishData: {},
  }),
  watch: {
    requestData: {
      handler(data) {
        if(data.RequestID){
        this.dialogModel = true;
        this.getPRCodeDetails();
        }
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    print() {
        window.open(this.apiUrl + "/request/report/" + this.requestData.RequestCode);
    },
    editREQ(){
    let data = this.requestData;
    this.formData.RequestTypeID = parseInt(data.RequestTypeID);
    this.formData.UsePPMP = data.BudgetCode ? true : false;
    this.formData.PPMPType = data.PPMPType.split(',');
    this.formData.PPMPBudgetCode = data.BudgetCode;
    this.formData.UsePR = data.PRCode ? true : false;
    this.formData.PRNumber = data.PRCode;
    this.formData.PRRevocation = data.PRRevocation;
    this.formData.AdditionalDescription = data.AdditionalDescription;
    this.formData.Others = data.Others == 1 ? true : false;
    this.formData.OtherDescription = data.OtherDescription;
    this.formData.Reason = data.Reason;
    this.editREQDialog = true;
    },
    closeDialog() {
      this.formData.Lists = [];
      this.itemList = [];
      this.dialogModel = false;
      this.eventHub.$emit("closeViewRequest", false);
    },
    unpublish(){
      this.dialogUnpublish = true;
    },
    getPRCodeDetails(){
          let data = new FormData();
          data.append("RequestID", this.requestData.RequestID)
          this.axiosCall(
              '/request/type/details',
              'POST',
              data
          )
          .then((res) => {
            if(res.data.status){
              this.unpublishItems = res.data.data.items
              this.unpublishData = res.data.data.data
            }
          })
      },
    confirmUpdate(){
      if(this.$refs.RequestUpdateFormRef.validate()){
        let data = new FormData();
        data.append("RequestID", this.requestData.RequestID);
        data.append('BudgetCode', this.budgetList.find(u => u.PPMPIDs == this.formData.PPMPBudgetCode).BudgetCode);
        data.append('PRCode', this.prList.find(u => u.PRID == this.formData.PRNumber).PRCODE);
        data.append('PPMPType', (this.formData.PPMPType).join(','));
        data.append('PRRevocation', this.formData.PRRevocation ? 1 : 0);
        data.append('AdditionalDescription', this.formData.AdditionalDescription ? 1 : 0);
        data.append('Others', this.formData.Others ? 1 : 0);
        data.append('OtherDescription', this.formData.OtherDescription || '');
        data.append('Reason', this.formData.Reason || '');
        data.append('Items', JSON.stringify(this.selectedItems));
        this.axiosCall("/request/edit", "POST", data).then((res) => {
          if(res.data.status){

            this.requestData.UsePPMP = this.formData.BudgetCode;
            this.requestData.PPMPType = this.formData.PPMPType.split(',');
            this.requestData.PPMPBudgetCode = this.formData.BudgetCode;
            this.requestData.UsePR = this.formData.PRNumber ? true : false;
            this.requestData.PRNumber = this.formData.PRNumber;
            this.requestData.PRRevocation = this.formData.PRRevocation;
            this.requestData.AdditionalDescription = this.formData.AdditionalDescription;
            this.requestData.Others = this.formData.Others == 1 ? true : false;
            this.requestData.OtherDescription = this.formData.OtherDescription;
            this.requestData.Reason = this.formData.Reason;

            this.formData = {
              RequestType: null,
                UsePPMP: false,
                PPMPType: [],
                PPMPBudgetCode: '',
                UsePR: false,
                PRNumber: '',
                PRRevocation: false,
                AdditionalDescription: false,
                Others: false,
                OtherDescription: null,
                Reason: null,
            };
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Request was successfully updated.";
            this.editREQDialog = false;
          }
          else{
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Something went wrong!";
          }
          });
      }
      else{
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Unable to proceed. Please check the details before submitting!";
      }
    },
    confirmUnpublish(){
      let data = new FormData();
      data.append("RequestID", this.requestData.RequestID);
      this.axiosCall("/request/unpublish", "POST", data).then((res) => {
        if(res.data.status){
        this.closeDialog();
          this.dialogUnpublish = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Return Slip was successfully unpublished";
          this.fadeAwayMessage.header = "System Message";
        }
        else{
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong!";
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
  },
};
</script>
        
    <style scoped>
.v-dialog--fullscreen,
.poModal {
  overflow-x: hidden !important;
}
</style>